// MODULES
import React from "react";
import Modal from "../../../../components/Modal/Modal";
import i18n from "../../../../helpers/i18n";

export default class SignConfirmationModal extends React.PureComponent {
	render() {
		const {visible, signUrls, onCloseModal, signOnNewTab, signatories} = this.props;

		function ShowSignatories(signUrls) {

			if (signUrls.signUrls.length === 1) {
				return (
          <li>
            <a
              href={signUrls.signUrls[0].PartyUrl}
              target={signOnNewTab ? "_blank" : "_self"}
              rel="noreferrer"
            >
              {signUrls.signUrls[0].Name}
            </a>
          </li>
        );
			}

			return (
				signUrls.signUrls.map((signUrl, index) => (
					<li key={index}>
						<a href={signUrl.PartyUrl} target={"_blank"} rel="noreferrer">{signUrl.Name}</a>
					</li>
				))
			);
		}

		let hasSmsSignatory = false;
		for (let i = 0; i < signatories.length; i++)
		{
			if (signatories[i].phone && signatories[i].phone.length > 0)
			{
				hasSmsSignatory = true;
			}
		}

		return (
			<Modal
				className="Cob-SignAgreement-SignModalConfirmation"
				visible={visible}
				title={i18n("general", "sign_agreement")}>

				<p>
					{hasSmsSignatory ? i18n("general", "documents_sent_1_sms") : i18n("general", "documents_sent_1")}
				</p>
				<p>{i18n("general", "documents_sent_2")}</p>

				<ul>
					<li><strong>{i18n("general", "documents_sent_signatories")}</strong></li>
					<ShowSignatories signUrls={signUrls}/>
				</ul>

				<div className={"actions"}>
					<Modal.ButtonsContainer>
						<Modal.Button
							label={i18n("general", "documents_sent_close")}
							onClick={onCloseModal}/>
					</Modal.ButtonsContainer>
				</div>
			</Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/SignModal/SignConfirmationModal.js